export default __webpack_public_path__ + "static/cognizant_4-3f051383fc142ebae18c2a09fa3494ec.jpeg";